import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { strings, getCurrentLocale } from 'APP_ROOT/localization';
import MyQueryRenderer from "../MyQueryRenderer";
import { csvFormat } from 'd3-dsv';
import moment from 'moment';
import ReactTable from 'react-table'; /* for the report tables */
import 'react-table/react-table.css';

import ProfileImage from 'APP_ROOT/components/ProfileImage';
import ErrorMessage from 'APP_ROOT/components/ErrorMessage';

import MaintenanceMessage from '../MaintenanceMessage';

const DATE_COLUMN = {
    Header: strings.reports_header_date,
    id: 'FactSegment.startTime',
    accessor: (y) => y['FactSegment.startTime'],
    maxWidth: 120,
    Cell: x => <a href={x.original._historyUrlOverride || `/${getCurrentLocale()}/stats/history/${x.original["DimRaven.uuid"]}/${x.original["DimCard.cardId"]}`} target="_blank"> { x.value && x.value[0] ? "" + moment(x.value[0]).local().format('MMM Do YYYY') + " - " + moment(x.value[1]).local().format('MMM Do YYYY'): '-' } </a>,
    aggregate: vals => {
        if(vals.length <= 0)
        {
            return null;
        }

        var min;
        var max;

        if(Array.isArray(vals[0]))
        {
            min = vals[0][0];
            max = vals[0][1];
        }
        else
        {
            min = vals[0];
            max = vals[0];
        }
        vals.forEach(x => {
            if(Array.isArray(x))
            {
                if(min > x[0]) min = x[0];
                if(max < x[1]) max = x[1];
            }
            else
            {
                if(min > x) min = x;
                if(max < x) max = x;
            }
        });
        if(min === max)
            return min;
        return [min, max];
    },
    Aggregated: (x) => (
        x.value ? (
            x.value instanceof Array ?
            (<div>{moment(x.value[0]).local().format('MMM Do YYYY')} - { moment(x.value[1]).local().format('MMM Do YYYY') }</div>)
            : (<div>{moment(x.value).local().format('MMM Do YYYY')}</div>)
        ) : <div>-</div>
    ),
};

class ReportsSection extends React.PureComponent {

    render() {
            // fieldName: 'DimVehicle.name',
            // tableColumnHeader: strings.reports_header_vehicle,
            // ifNull: strings.unknown,

        return (
            <MyQueryRenderer
                user={this.props.user}
                cubejsApi={this.props.cubejsApi}
                query={{
                    "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone,
                    "measures": [
                        "FactDTC.count",
                    ],
                    "timeDimensions": [
                        {
                            "dimension": "FactSegment.startTime",
                            "dateRange": [
                                moment(this.props.selectedDateRange[0]).format('YYYY-MM-DD'),
                                moment(this.props.selectedDateRange[1]).format('YYYY-MM-DD'),
                            ]
                        }
                    ],
/*
                    filters: [
                        {
                            "dimension": "FactDTC.type",
                            "operator": "equals",
                            "values": [ 'stored', 'permenant' ]
                        }
                    ],
*/
                    "dimensions": [
                        'DimVehicle.name',
                        'DimVehicle.make',
                        'DimVehicle.model',
                        'DimVehicle.year',
                        'DimVehicle.vin',
                        "DimRaven.uuid",
                        "DimCard.cardId",
                        'FactDTC.code',
                        'FactDTC.type',
                        'FactDTC.mil',
                        'FactSegment.startTime'
                    ]
                }}
                render={this.renderChart(ConnectedEventTable, this.props)}
            />
        );
    }

    renderChart = (Component, props) => ({ resultSet, error, ...otherProps }) => {
        if (error) {
            return this.renderError(error);
        } else if(resultSet) {
            return <Component 
                        {...otherProps} 
                        stage={props.user.stage} 
                        resultSet={resultSet}
                        limitTo={props.limitTo}
                        limitToFilteredResources={props.limitToFilteredResources}
                    />;
        } else {
            return <div>{strings.loading}</div>;
        }
    }

    renderError = error => {
        if(error.message && error.message.match(/maintenance/i)) {
            return <MaintenanceMessage message={error.message} />;
        } else {
            return <ErrorMessage error={error} />;
        }
    }
}

class EventTable extends React.PureComponent {

    componentDidMount() {
    }

    componentDidUpdate() {
    }

    generateExportURI = (columns, rawRows) => {
        const outputRows = rawRows.map(row => {
            const outRow = {};
            columns.forEach(col => {
                if(col.show || col.show === undefined) {
                    outRow[col.Header] = (typeof col.accessor === 'string' ? row[col.accessor] : col.accessor(row));
                }
            });
            return outRow;
        });
        const BOM='\uFEFF';
        return `data:text/csv;charset=utf-8,${BOM}${encodeURIComponent(csvFormat(outputRows))}`;
    }

    /* bundle aggregate values in a single value (string) such that they can be separated during render (in "Aggregated")*/
    generateAggregatedToPreserveIndividualValues (valuesArray) {
        return JSON.stringify(valuesArray); // TODO values are actually single items, what am I missing here?
    }

    /* separates the values bundled in a single string (in generateAggregatedToPreserveIndividualValues) and return the array of parsed values to be rendered */
    getValuesArrayFromAggregated (aggregatedRowValue) {

        const arrayOfJSONObjectStrings = JSON.parse(aggregatedRowValue);

        return arrayOfJSONObjectStrings;

        const valuesArray = arrayOfJSONObjectStrings.map(jsonObject => {
            const parsedValue = JSON.parse(jsonObject);
            if (!parsedValue && parsedValue !== 0) {
                return null;
            }
            return parsedValue;
        });

        return valuesArray;
    };

    standardAggregate = (vals) => {
        if(vals.length <= 0)
        {
            return null;
        }
        var myset = new Set();

        vals.forEach(x => {
            myset.add(x);
        });

        var result = [];

        myset.forEach( (it) => {
            result.push(it);
        });
        return this.generateAggregatedToPreserveIndividualValues(result);
    };

    standardAggregated = (row) => {
        const values = this.getValuesArrayFromAggregated(row.value);

        return (  /* mimicking default ReactTable <span> rendering (for example, groupBy "driver,vehicle" below renders using <span> since we don't custom aggregate */
            <span>
                {values.map((value, index) => {
                    return  <span key={index}>
                        {value}
                        {index === values.length - 1 ? "" : ","}
                    </span>
                })}
            </span>
        )
    };

    standardAggregatedWithNullValue(nullValue) { 
        return (row) => {

            if(!row.value || row.value === '[null]') return nullValue;

            const values = this.getValuesArrayFromAggregated(row.value);

            return (  /* mimicking default ReactTable <span> rendering (for example, groupBy "driver,vehicle" below renders using <span> since we don't custom aggregate */
                <span>
                    {values.map((value, index) => {
                        return  <span key={index}>
                            {value}
                            {index === values.length - 1 ? "" : ","}
                        </span>
                    })}
                </span>
            )
        };
    };

    render() {
        const {resultSet, stage } = this.props;

        return this.tableRender(resultSet, stage);

    }

    tableRender = (resultSet, stage) => {

        const filteredRawData = this.props.limitToFilteredResources(resultSet.rawData(), this.props.limitTo);

        const columns = [
                {   
                    Header: strings.reports_header_name,
                    accessor: (y) => y['DimVehicle.name'], 
                    id: 'DimVehicle.name' 
                },
                {
                    Header: strings.reports_header_vehicle,
                    accessor: d => "" + 
                        (d["DimVehicle.year"] ? d["DimVehicle.year"] : '') + " " + 
                        (d['DimVehicle.make'] ? d['DimVehicle.make'] : '') + " " + 
                        (d['DimVehicle.model'] ? d['DimVehicle.model'] : ''),
                    id: 'DimVehicle.make',
                    Cell: x => { if (x.value) return ( <div title={x.original["DimVehicle.vin"]}> { x.value } </div> ); return (<div>{strings.reports_vehicle_name_unknown}</div>); },
                    aggregate: this.standardAggregate,
                    Aggregated: this.standardAggregatedWithNullValue(strings.reports_vehicle_name_unknown)
                },
                {   
                    Header: strings.reports_header_vin, 
                    accessor: (y) => y['DimVehicle.vin'], 
                    id: 'DimVehicle.vin' ,
                    aggregate: this.standardAggregate,
                    Aggregated: this.standardAggregated
                },
                {   
                    Header: strings.alerts_event_obd_dtc_alert,
                    accessor: (y) => y['FactDTC.code'], 
                    id: 'FactDTC.code',
                    aggregate: this.standardAggregate,
                    Aggregated: this.standardAggregated
                },
                DATE_COLUMN
        ];


        // Reduce the results coming back to min/max time for each DTC for each vehicle.

        const obj = filteredRawData.reduce((acc, it) => {

            const key = it['DimRaven.uuid'] + it['FactDTC.code'];
            if(!acc[key]) {
                acc[key] = { ...it };

                acc[key]['mindate'] = it['FactSegment.startTime'];
                acc[key]['maxdate'] = it['FactSegment.startTime'];
                acc[key]['count'] = 0;
            }
            acc[key]['count'] ++;
            if(acc[key]['mindate'] > it['FactSegment.startTime'])
            {
                acc[key]['mindate'] = it['FactSegment.startTime'];
            }
            if(acc[key]['maxdate'] < it['FactSegment.startTime'])
            {
                acc[key]['maxdate'] = it['FactSegment.startTime'];
            }

            acc[key]['FactSegment.startTime'] = [acc[key]['mindate'], acc[key]['maxdate']];

            return acc;
        }, {});

        const rows = Object.values(obj);

        if(!rows || rows.length <= 0)
        {
            return (
                <div>
                    <h4>{strings.reports_no_data_for_selected_time_period}</h4>
                </div>
            );
        }

        const exportURI = this.generateExportURI(columns, rows);

        return (
            <div>
                <ReactTable
                    data = {rows}
                    columns = {columns}
                    noDataText={strings.reports_no_data_for_selected_time_period}
                    showPagination = {false}
                    defaultPageSize = {Number.MAX_SAFE_INTEGER} // RAV-1942, step one (effectively "set the page size to the number of rows" returned from the database)
                    minRows = {0} /* 0, do not show empty filler rows */
                    pivotBy = { [ 'DimVehicle.name' ] }
                    defaultSorted={[
                        { id: 'DimVehicle.name',
                          desc: false
                        },
                        { id: 'FactSegment.startTime',
                          desc: false
                        },
                        { id: 'FactDTC.code',
                          desc: false
                        }
                    ]}
                    getTrProps={(state, rowInfo, column) => {
                        if(rowInfo && rowInfo.aggregated)
                            return { className: '-rollup' };
                        return { className: '-padRow'};
                    }}
                />
                <div className='text-right mt-1'>
                    <a
                        className='btn btn-outline-blue btn-sm'
                        download="event-report.csv"
                        id="export-link"
                        href={exportURI}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {strings.action_export_CSV}
                    </a>
                </div>

            </div>
        );
    }

}

const ConnectedEventTable = connect()(EventTable);

ReportsSection.propTypes = {
    selectedDateRange: PropTypes.instanceOf(Array).isRequired
}

export default ReportsSection;

